import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { LocalAuxData } from 'src/app/api/interfaces/user';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {

  @Input('bank') bank: boolean;
  @Input('valid') valid: boolean;
  @Input('disable') disable: boolean;
  @Input('contact') contact: boolean;
  @Input('personal') personal: boolean;
  @Input('objetives') objetives: boolean;
  @Input('background') background: boolean;
  @Input('physiological') physiological: boolean;
  @Input('achievements') achievements: boolean;

  @Output() editEvent = new EventEmitter<boolean>();
  @Output() onSubmitEvent = new EventEmitter<any>();

  objetivesValid: boolean = false;
  achievementsValid: boolean = false;
  showEdit: boolean = true;

  constructor(
    private sharedData: SharedDataService
  ) { }

  ngOnInit(): void {
    this.sharedData.currentMessage.subscribe(message => {
      //validacion de objetivos
      if (message === "objetivesValid") {
        this.objetivesValid = true;
      }
      if (message === "objetivesInvalid") {
        this.objetivesValid = false;
      }

      //validacion de metas
      if (message === "achievementsValid") {
        const auxruta: LocalAuxData = JSON.parse(sessionStorage.getItem('localAuxDataruta'));
        const auxpista: LocalAuxData  = JSON.parse(sessionStorage.getItem('localAuxDatapista'));
        const auxtrail: LocalAuxData  = JSON.parse(sessionStorage.getItem('localAuxDatatrail'));
        const auxultra: LocalAuxData  = JSON.parse(sessionStorage.getItem('localAuxDataultra'));

        let contadorTotal: number = 0;
        let contadorValid: number = 0;
        if(auxruta) {
          contadorTotal++;
          if(auxruta.valid) {
            contadorValid++;
          }
        }
        if(auxpista) {
          contadorTotal++;
          if(auxpista.valid) {
            contadorValid++;
          }
        }
        if(auxtrail) {
          contadorTotal++;
          if(auxtrail.valid) {
            contadorValid++;
          }
        }
        if(auxultra) {
          contadorTotal++;
          if(auxultra.valid) {
            contadorValid++;
          }
        }

        // this.achievementsValid =  true;
        this.achievementsValid =  (contadorTotal == contadorValid);
      }
      if (message === "achievementsInvalid") {
        this.achievementsValid = false;
      }

    });
    const estado: string = sessionStorage.getItem('estado');
    if(estado != 'A') {
      this.showEdit = false;
    }
  }

  edit() {
    this.editEvent.emit(!this.disable);
    if(this.objetives) {
      this.sharedData.changeMessage("editObjetives");
    }
    if(this.achievements) {
      this.sharedData.changeMessage("editAchievements");
    }
  }

  onSubmit() {
    this.onSubmitEvent.emit();
    if(this.objetives) {
      this.sharedData.changeMessage("saveObjetives");
    }
    if(this.achievements) {
      this.sharedData.changeMessage("saveAchievements");
    }
  }

}
